"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

exports.implementation = /*#__PURE__*/function () {
  function AttrImpl(_, privateData) {
    _classCallCheck(this, AttrImpl);

    this._namespace = privateData.namespace !== undefined ? privateData.namespace : null;
    this._namespacePrefix = privateData.namespacePrefix !== undefined ? privateData.namespacePrefix : null;
    this._localName = privateData.localName;
    this._value = privateData.value !== undefined ? privateData.value : "";
    this._element = privateData.element !== undefined ? privateData.element : null;
    this.specified = true;
  }

  _createClass(AttrImpl, [{
    key: "namespaceURI",
    get: function get() {
      return this._namespace;
    }
  }, {
    key: "prefix",
    get: function get() {
      return this._namespacePrefix;
    }
  }, {
    key: "localName",
    get: function get() {
      return this._localName;
    }
  }, {
    key: "name",
    get: function get() {
      return exports.getAttrImplQualifiedName(this);
    } // Delegate to name

  }, {
    key: "nodeName",
    get: function get() {
      return this.name;
    }
  }, {
    key: "value",
    get: function get() {
      return this._value;
    },
    set: function set(v) {
      if (this._element === null) {
        this._value = v;
      } else {
        exports.changeAttributeImpl(this._element, this, v);
      }
    } // Delegate to value

  }, {
    key: "nodeValue",
    get: function get() {
      return this.value;
    },
    set: function set(v) {
      this.value = v;
    } // Delegate to value

  }, {
    key: "textContent",
    get: function get() {
      return this.value;
    },
    set: function set(v) {
      this.value = v;
    }
  }, {
    key: "ownerElement",
    get: function get() {
      return this._element;
    }
  }]);

  return AttrImpl;
}();

exports.changeAttributeImpl = function (element, attributeImpl, value) {
  // https://dom.spec.whatwg.org/#concept-element-attributes-change
  // TODO mutation observer stuff
  var oldValue = attributeImpl._value;
  attributeImpl._value = value; // Run jsdom hooks; roughly correspond to spec's "An attribute is set and an attribute is changed."

  element._attrModified(exports.getAttrImplQualifiedName(attributeImpl), value, oldValue);
};

exports.getAttrImplQualifiedName = function (attributeImpl) {
  // https://dom.spec.whatwg.org/#concept-attribute-qualified-name
  if (attributeImpl._namespacePrefix === null) {
    return attributeImpl._localName;
  }

  return attributeImpl._namespacePrefix + ":" + attributeImpl._localName;
};